import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { createCalibrationReport } from "../../../services/CalibrationService";
import { Modal } from "react-bootstrap";

const GenerateCalibrationReportModal = ({ data, handleAfterUpdate }) => {
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [dataInput, setDataInput] = useState({
    calibration_id: data?.id,
    report_file: null,
  });
  const [showModal, setShowModal] = useState(false);
  const [fileError, setFileError] = useState("");

  const openModal = () => setShowModal(true);

  const closeModal = () => {
    setDataInput({
      calibration_id: data?.id,
      report_file: null,
    });
    setFileError("");
    setShowModal(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [".pdf", ".docx", ".xlsx"];
      const fileType = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

      if (!allowedTypes.includes(fileType)) {
        setFileError("Invalid file type. Accepted formats: PDF, DOCX, XLSX.");
        setDataInput({ ...dataInput, report_file: null });
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        setFileError("File size exceeds 2MB.");
        setDataInput({ ...dataInput, report_file: null });
        return;
      }

      setFileError("");
      setDataInput((prev) => ({ ...prev, report_file: file }));
    }
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitLoading(true);
      const formData = new FormData();
      formData.append("calibration_id", dataInput.calibration_id);
      formData.append("report_file", dataInput.report_file);
  
      const response = await createCalibrationReport(formData);
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to submit report.");
    } finally {
      setIsSubmitLoading(false);
    }
  };  

  const getFileIcon = (fileType) => {
    switch (fileType) {
      case ".pdf":
        return <i className="fa fa-file-pdf" style={{ fontSize: "2rem", color: "#d9534f" }}></i>;
      case ".docx":
        return <i className="fa fa-file-word" style={{ fontSize: "2rem", color: "#0078d4" }}></i>;
      case ".xlsx":
        return <i className="fa fa-file-excel" style={{ fontSize: "2rem", color: "#28a745" }}></i>;
      default:
        return null;
    }
  };

  return (
    <>
      <button
        className="btn btn-outline-primary btn-sm mt-3"
        onClick={openModal}
      >
        <i className="fa-solid fa-file-pdf me-2"></i>Generate Report
      </button>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Calibration Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <div
              className="d-flex flex-column align-items-center justify-content-center border-dotted p-4"
              style={{
                border: "2px dashed #8713d1",
                borderRadius: "8px",
                backgroundColor: "#f8f9fa",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => document.getElementById("report_file").click()}
            >
              {!dataInput.report_file ? (
                <>
                  <i
                    className="fa fa-cloud-upload-alt"
                    style={{ fontSize: "2rem", color: "#6c757d" }}
                  ></i>
                  <p className="mt-3 mb-0 text-muted">
                    Drag and drop your file here, or click to browse
                  </p>
                  <small className="text-muted">
                    Accepted formats: PDF, DOCX, XLSX (Max size: 2MB)
                  </small>
                </>
              ) : (
                <div>
                  {getFileIcon(dataInput.report_file.name.slice(dataInput.report_file.name.lastIndexOf(".")))}
                  <p className="mt-3 mb-0 text-success">
                    <strong>Selected File:</strong> {dataInput.report_file.name}
                  </p>
                </div>
              )}
              {fileError && <p className="text-danger mt-2">{fileError}</p>}
              <input
                type="file"
                id="report_file"
                className="form-control d-none"
                name="report_file"
                accept=".pdf,.docx,.xlsx"
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-primary me-3"
              onClick={handleSubmit}
              disabled={isSubmitLoading || !dataInput.report_file}
            >
              {isSubmitLoading ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GenerateCalibrationReportModal;
